<template>
  <div name="topicReprint">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">轉載來源</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">話題</li>
              <li class="breadcrumb-item active">轉載來源</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-article" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-10"></div>
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              @click="addReprintfuc()"
            >
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增轉載來源
            </button>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table
                  :data="getTopicReprintModel"
                  row-key="id"
                  border
                  v-loading="isloading"
                >
                  <el-table-column label="轉載來源">
                    <template slot-scope="scope">
                      <div class="b-source-block mr-2 clearfix">
                        <div class="b-source-thumbnail">
                          <div class="b-source-responsive">
                            <div class="b-source-sizer">
                              <div
                                class="b-source-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + `${scope.row.sgL_ImageUrl}` + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="b-title">
                        <a href>{{ scope.row.sgL_Title }}</a>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="簡介"
                    prop="sgL_Content"
                  ></el-table-column>
                  <el-table-column
                    label="連結"
                    prop="sgL_Url"
                  >
                  <template slot-scope="scope">
                    <a :href="scope.row.sgL_Url" target="blank">{{scope.row.sgL_Url}}</a>
                  </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="editReprintFuc(scope.row.id)"
                        >編輯</el-button
                      >
                      <el-popconfirm
                        title="確定刪除嗎？"
                        @onConfirm="delReprint(scope.row.id)"
                      >
                        <el-button size="mini" type="danger" slot="reference"
                          >删除</el-button
                        >
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
        <!-- Modal: 新增/編輯轉載來源 -->
        <el-dialog
          title="新增/編輯轉載來源"
          :close-on-click-modal="false"
          :visible.sync="editIsShow"
        >
          <el-form
            :model="editReprint"
            ref="editReprint"
            :rules="editReprintRules"
            label-width="120px"
          >
            <el-form-item label="圖片">
              <el-upload
                ref="upload"
                :action="uploadurl + '&id=' + this.user.userId"
                class="upload-demo"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleRemove"
                :limit="1"
                :file-list="fileList"
                list-type="picture"
              >
                <el-button size="small" type="primary">點擊上傳</el-button>
                <div slot="tip" class="el-upload__tip">
                  只支援jpg/png格式，且不超過5M
                </div>
              </el-upload>
              <img v-if="imageUrl" :src="imageUrl" style="width: 305px" />
            </el-form-item>
            <el-form-item label="轉載來源" prop="sgL_Title">
              <el-input v-model="editReprint.sgL_Title"></el-input>
            </el-form-item>
            <el-form-item label="簡介">
              <el-input v-model="editReprint.sgL_Content"></el-input>
            </el-form-item>
            <el-form-item label="鏈接">
              <el-input v-model="editReprint.sgL_Url"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input type="hidden" v-model="editReprint.id"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancleUpdate()">取消</el-button>
            <el-button type="primary" @click="submitForm('editReprint')"
              >確定</el-button
            >
          </div>
        </el-dialog>
        <!-- /.modal: 新增/編輯文章類型 -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import base from "../../api/httpApi/base";
import { Message } from "element-ui";
export default {
  data() {
    return {
      uploadurl: `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=source`,
      isloading: false,
      imageUrl: null,
      user: null,
      fileList: null,
      topicReprintModel: [],
      editReprintRules: {
        sgL_Title: [
          { required: true, message: "請輸入轉載來源", trigger: "blur" },
        ],
      },
      editIsShow: false,
      editReprint: {
        sgL_ImageId: null,
        sgL_Title: "",
        sgL_Content: "",
        id: "",
        sgL_Url: "",
      },
    };
  },
  created() {
    this.GetReprintList();
    this.user = this.$store.getters.getUser;
  },
  methods: {
    GetReprintList() {
      this.$api.TopicApi.GetReprintList().then((res) => {
        if (res.data.success) {
          this.topicReprintModel = res.data.result.items;
        }
      });
    },
    //提交數據
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            sgL_ImageId: this.editReprint.sgL_ImageId,
            sgL_Url: this.editReprint.sgL_Url,
            sgL_Title: this.editReprint.sgL_Title,
            sgL_Content: this.editReprint.sgL_Content,
          };
          if (this.editReprint.id != "") {
            //修改
            params.id = this.editReprint.id;
            this.$api.TopicApi.EditReprint(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                Message({
                  type: "error",
                  message: "修改失敗",
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.GetReprintList();
            });
          } else {
            //添加
            this.$api.TopicApi.AddReprint(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "添加成功",
                });
              } else {
                Message({
                  type: "error",
                  message: "添加失敗",
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.GetReprintList();
            });
          }
        }
      });
    },
    editReprintFuc(id) {
      let msg = "";
      let params = {
        Id: id,
      };
      this.editReprint = this.$options.data().editReprint; //置空表单
      this.editIsShow = true;
      this.$api.TopicApi.getReprintByid(params).then((res) => {
        if (res.data.success) {
          let typeModel = res.data.result;
          if (typeModel == null) return;
          //赋值给model
          this.imageUrl = typeModel.sgL_ImageUrl;
          this.editReprint.sgL_ImageId = typeModel.sgL_ImageId;
          this.editReprint.sgL_Url = typeModel.sgL_Url;
          this.editReprint.sgL_Title = typeModel.sgL_Title;
          this.editReprint.sgL_Content = typeModel.sgL_Content;
          this.editReprint.id = typeModel.id;
        } else {
          Message({
            type: "warning",
            message: "未找到該信息",
          });
        }
      });
    },
    addReprintfuc() {
      this.imageUrl = null;
      this.editReprint = this.$options.data().editReprint; //置空
      this.editIsShow = true;
    },
    cancleUpdate() {
      this.editIsShow = false;
      this.$refs.upload.clearFiles();
    },
    delReprint(id) {
      let params = {
        Id: id,
      };
      this.$api.TopicApi.DelReprint(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: "刪除成功",
          });
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
        this.GetReprintList();
      });
    },
    //#region 上传图片
    handleAvatarSuccess(res, file) {
      this.editReprint.sgL_ImageId = res.result.uploadId;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const ispng = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !ispng) {
        this.$message.error("上传封面图片只能是 JPG /png格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传封面图片大小不能超过 5MB!");
      }
      return (isJPG || ispng) && isLt5M;
    },
    handleRemove() {
      this.imageUrl = "";
    },
    //#endregion
  },
  computed: {
    getTopicReprintModel() {
      return this.topicReprintModel;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminTopic/TopicReprint.vue